<template>
  <popup name="popup" height="auto" :scrollable="true">
    <div class="b-dialog__top-panel">
      <h2>{{ title }}</h2>
      <button class="b-btn b-btn_border_none" @click="hide">
        <dynamic-icon icon="close"/>
      </button>
    </div>
    <div class="p-8">
      <p class="dialog-message">{{ message }}</p>
      <div class="row pr-6 pt-6">
        <button class="b-btn b-btn_type_empty ml-auto" @click="hide">{{ $t('CONTENT.no') }}</button>
        <button class="b-btn b-btn_type_primary ml-6" @click="onOkClick">{{ $t('CONTENT.yes') }}</button>
      </div>
    </div>
  </popup>
</template>
<script>
export default {
  name: 'confirmation-modal',
  data() {
    return {
      title: this.$t('CONTENT.confirm'),
      message: 'Message',
      onOk: () => {
      }
    };
  },
  methods: {
    show(params) {
      Object.keys(params)
        .forEach(k => this[k] = params[k]);
      this.$modal.show('popup');
    },
    hide() {
      this.$modal.hide('popup');
    },
    onOkClick() {
      this.onOk();
      this.hide();
    }
  },
};
</script>
<style scoped>
.dialog-message {
  font-size: 16px;
}
</style>
